import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  meshurl: cacheLs.get_mesh_url()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
